<div class="container">
  <mat-card class="card2">
          <h4 class="card-title">ADD RESTAURANT</h4>
  
      <form  (ngSubmit)="f.form.valid && AddRestaurant()" #f="ngForm">
          <label>
              <img [src]="addForm.image.url" #ima class="img1">
              <input type="file"  accept="image/*" (onclick)="ima" (change)="showPreview($event)" hidden/>
            </label>
            <div *ngIf="currentUpload">
              Progress: {{ currentUpload?.progress }}%
              Complete
              <div class="progress">
                <div
                  class="progress-bar progress-bar-animated"
                  [ngStyle]="{ width: currentUpload?.progress + '%' }"
                ></div>
                </div></div>
            <div *ngIf="delete1"><mat-icon class="delete" (click)="deletePreviousFile()">delete</mat-icon></div><br>
        <div class="row">
          <div class="col-md-4">
         
            <mat-form-field class="example-full-width">
          
              <mat-label>Name</mat-label>
              <input matInput placeholder="Name" name="name" [(ngModel)]="addForm.name"  #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" required />
              <span matPrefix><mat-icon>face</mat-icon></span>
              <!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback abcd">
                <div *ngIf="firstName.errors.required">Name is required</div>
            </div>   -->
            </mat-form-field>
             
            <div
            [hidden]="firstName.valid || firstName.pristine"
            class="erro1"
          >Name is Required
          </div>
            </div>
          <div class="col-md-4">
  
            <mat-form-field class="example-full-width">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" name="email" type="email" [(ngModel)]="addForm.email"#email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email />
           
              <span matPrefix><mat-icon>email</mat-icon></span>
              <!-- <div *ngIf="f.submitted && email.invalid" class="invalid-feedback abcd">
                  <div *ngIf="email.errors.required">Email is required</div>
                  <div *ngIf="email.errors.email">Email must be a valid email address</div>
              </div> -->
  
            </mat-form-field>
           <div
              [hidden]="email.valid || email.pristine"
              class="erro1"
            >
              <div *ngIf="email.errors?.required">Email is required</div>
              <div *ngIf="email.errors?.email">
                Email must be a valid email address
              </div></div>
  </div>
              <div class="col-md-4">
  
                <mat-form-field class="example-full-width">
                  <mat-label>Phone</mat-label>
                  <input matInput placeholder="Phone No" type="tel" pattern="[789][0-9]{9}" name="phone" type="tel" [(ngModel)]="addForm.phone"#phone="ngModel" required minlength="10" maxlength='10'>
                  <span matPrefix>   <mat-icon>phone</mat-icon></span>
                  <!-- <div *ngIf="f.submitted && phone.invalid" class="invalid-feedback abcd">
                    <div *ngIf="phone.errors.required">Phone is required</div>
                </div> -->
                </mat-form-field> 
                
                <div
                [hidden]="phone.valid || phone.pristine"
                class="erro1"
              >
             Valid Phone is required.
              </div>
            
            
            <!-- <mat-form-field class="example-full-width">
           
                  <mat-label>Payment Option</mat-label>
                  <mat-select #mySel matNativeControl [(ngModel)]="addForm.paymentOption" name="unit" multiple="true"  (selectionChange)="paymentChange($event.value)">
                      <mat-option [value]="0" (click)="toggleAllSelection()">All</mat-option>
                    <mat-option [value]="credit" >Credit</mat-option>
                    <mat-option [value]="debit">Debit</mat-option>
                    <mat-option [value]="upi">UPI</mat-option>
  
                  </mat-select>
            </mat-form-field> -->
           
              </div>
          <div class="col-md-4">
            <mat-form-field class="example-full-width">
              <mat-label>Password</mat-label>
              <input matInput placeholder="Password" name="password" type="password" [(ngModel)]="addForm.password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required />
              <span matPrefix><mat-icon>lock</mat-icon></span>
              <!-- <div *ngIf="f.submitted && password.invalid" class="invalid-feedback abcd">
                <div *ngIf="password.errors.required">Password is required</div>
            </div> -->
            </mat-form-field>
            <div
            [hidden]="password.valid || password.pristine"
            class="erro1"
          >
            Password is required.
          </div>
          
  </div>
  <!-- <div class="col-md-4">
    <mat-form-field class="example-full-width">
      <mat-label>Zipcode</mat-label>
      <input matInput placeholder="Enter Zip Code" name="zipcode"  pattern="[0-9]{6}" [(ngModel)]="addForm.zipcode" #zipcode="ngModel" minlength='6' maxlength="6" required/>
      <span matPrefix><mat-icon>pin_drop</mat-icon></span>
     <div *ngIf="f.submitted && password.invalid" class="invalid-feedback abcd">
        <div *ngIf="password.errors.required">Password is required</div>
    </div>
    </mat-form-field>
    <div
    [hidden]="zipcode.valid || zipcode.pristine"
    class="erro1" 
  >
    Valid Pincode Required
  </div>
  <div
  *ngIf="zipcode.dirty && zipcode.valid"
  class="erro1" 
>{{getDetailFromPincode(addForm.zipcode)}} 
</div>
  
</div> -->
<!-- <div class="col-md-4">
  <mat-form-field class="example-full-width">
    <mat-label>City</mat-label>
    <input matInput name="city" [(ngModel)]="addForm.city" disabled required/>
    <span matPrefix><mat-icon>location_city</mat-icon></span>
    -- <div *ngIf="f.submitted && password.invalid" class="invalid-feedback abcd">
      <div *ngIf="password.errors.required">Password is required</div>
  </div>
  </mat-form-field>

</div> -->
<!-- <div class="col-md-4">
  <mat-form-field class="example-full-width">
    <mat-label>State</mat-label>
    <input matInput placeholder="Enter Zip Code" name="state" [(ngModel)]="addForm.state" disabled required/>
    
     <div *ngIf="f.submitted && password.invalid" class="invalid-feedback abcd">
      <div *ngIf="password.errors.required">Password is required</div>
  </div>
  </mat-form-field>

</div>
   -->
 
          <div class="col-md-4">
  
            <mat-form-field class="example-full-width">
              <mat-label>Address</mat-label>
              <input matInput placeholder="Address" name="address" [(ngModel)]="addForm.address" value="">
              <span matPrefix><mat-icon>location_on</mat-icon></span> 
            </mat-form-field>
           
  </div>
  <div class="col-md-4">
    <!-- <mat-form-field>
      <mat-label>Select Catagory</mat-label>
      <mat-select [(ngModel)]="addForm.catagory_id" name="catagory_id" placeholder="Select Catagory" (selectionChange)="catada($event)" multiple #cat="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cat.invalid }" required>
        <mat-option *ngFor="let catagory of catagories" [value]="catagory">{{catagory.title}}
            <mat-select multiple  *ngIf="catagory.subcatagories">
              <mat-option *ngFor="let subCatagory of catagory.subcatagories" [value]="subCatagory">{{subCatagory.title}}</mat-option>
             </mat-select> 
        </mat-option>

      </mat-select>
      
    </mat-form-field> -->
    <mat-form-field>
      <mat-label>Select Catagory</mat-label>
      <mat-select [(ngModel)]="addForm.catagories" (selectionChange)="enableSubctatgory($event)" name="catagory_id" placeholder="Select Catagory"  multiple #cat="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cat.invalid }" required>
        <mat-option *ngFor="let catagory of catagories" [value]="catagory.id">{{catagory.title}}
          <mat-select multiple *ngIf="catagory.subcatagories" name="sub" [disabled]="addForm.catagories.includes(catagory.id)" [(ngModel)]="addForm.subcatagories">
            <mat-option *ngFor="let subCatagory of catagory.subcatagories"  [value]="subCatagory.id">{{subCatagory.title}}</mat-option>
           </mat-select> 
        </mat-option>

      </mat-select>
      
    </mat-form-field>
    <div
  [hidden]="cat.valid || cat.pristine"
  class="erro1"
>Catagory is Required
</div>
</div>
  <div class="col-md-4">
    <mat-form-field>
      <mat-label>Select Cuisine</mat-label>
      <mat-select [(ngModel)]="addForm.cuisine" name="cuisine" placeholder="Select Cuisine" #cuisine="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cuisine.invalid }">
        <mat-option value="veg">Veg</mat-option>
        <mat-option value="non-veg">Non-Veg</mat-option>
        <mat-option value="both">Both</mat-option>
      </mat-select>
    </mat-form-field>
    <div
  [hidden]="cuisine.valid || cuisine.pristine"
  class="erro1"
  >cuisine is Required
  </div>
  </div>
  <div class="col-md-4">
    <mat-form-field class="example-full-width">
      <mat-label>Select Voucher</mat-label>
          <mat-select  matNativeControl [(ngModel)]="addForm.voucher_id" name="unit"> 
             <mat-option *ngFor="let voucher of voucher" [value]="voucher.id">{{voucher.code}}</mat-option>
            </mat-select>
    </mat-form-field>
  </div>


              <div class="col-md-4">
                <mat-form-field class="example-full-width">
                  <mat-label>Alternative Phone </mat-label>
                  <input matInput placeholder="Alternative Phone " pattern="[789][0-9]{9}" name="phone2" [(ngModel)]="addForm.phone2" type="tel" value="" #tel="ngModel" minlength="10" maxlength='10'>
                </mat-form-field>
                <div
                [hidden]="tel.valid || tel.pristine"
                class="erro1"
              >
                Check Phone.
              </div>
           </div>
          <div class="col-md-4">
            <mat-form-field class="example-full-width">
              <mat-label>Delivery Time </mat-label>
              <input matInput placeholder="Delivery Time " type="number" name="dtime" [(ngModel)]="addForm.dtime" value="">
              
            </mat-form-field>
            </div>
          <div class="col-md-4">
  
            <mat-form-field class="example-full-width">
              <mat-label>Price For 2 Person</mat-label>
              <input matInput placeholder="Price For 2 Person" name="price" type="number" [(ngModel)]="addForm.price" value="">
              
            </mat-form-field>
  </div>
  <div class="col-md-4">
    <mat-form-field>
      <mat-label>Give Free Delight</mat-label>
      <mat-select [(ngModel)]="addForm.delight_type" name="Gift" placeholder="Select Delight">
        <mat-option>None</mat-option>
        <mat-option value="true">Yes</mat-option>
        <mat-option value="false">No</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  
  <div class="col-md-4">
    <mat-form-field class="example-full-width">
      <mat-label>Free Delight Order Above</mat-label>
      <input [disabled]="!addForm.delight_type || addForm.delight_type=='false'" matInput placeholder="Free Delight Order Above" name="Delight" [(ngModel)]="addForm.Delight" type="number" value="" #Delight="ngModel" required>
    </mat-form-field>
    <div
    [hidden]="Delight.valid || Delight.pristine"
    class="erro1"
  >
    Required Item Cannot Be Empty
  </div>
</div>
  <div class="col-md-4">
  
    <mat-form-field class="example-full-width">
      <mat-label>Discount Percentage On All Order</mat-label>
      <input matInput placeholder="Discount Percentage On All Order" name="discountPercentage" type="number" [(ngModel)]="addForm.discountPercentage" value="">
      
    </mat-form-field>
</div>
<div class="col-md-4">

  <mat-form-field class="example-full-width">

<mat-label>Max Fix Amount</mat-label>
<input matInput placeholder="Max Fix Amount" [disabled]="!addForm.discountPercentage" name="fixamount" [(ngModel)]="addForm.fixamount" #fixamount="ngModel" [ngClass]="{ 'is-invalid': f.submitted && fixamount.invalid }" required />

<!-- <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
<div *ngIf="firstName.errors.required">Name is required</div>
</div>        -->
</mat-form-field>

<div
[hidden]="fixamount.valid || fixamount.pristine"
class="erro1"
>Fixamount is Required
</div>
</div>  
<div class="col-md-4">
  
  <mat-form-field class="example-full-width">
    <mat-label>Order Above</mat-label>
    <input matInput placeholder="Order Above" name="OrderAbove" type="number" [(ngModel)]="addForm.OrderAbove" value="">
    
  </mat-form-field>
</div>

<div class="col-md-4">
  
  <mat-form-field class="example-full-width">
    <mat-label>Opening Time</mat-label>
    <input matInput placeholder="Open Time" name="open" type="time" [(ngModel)]="addForm.open" value="" #open="ngModel" required>
  </mat-form-field>
  <div
  [hidden]="open.valid || open.pristine"
  class="erro1"
>
  Open Time Is Required
</div>
</div>
<div class="col-md-4">
  
  <mat-form-field class="example-full-width">
    <mat-label>Close Time</mat-label>
    <input matInput placeholder="Close Time" name="close" type="time" [(ngModel)]="addForm.close" value="" #close="ngModel"  required>
  </mat-form-field>
  <div
  [hidden]="close.valid || close.pristine"
  class="erro1"
>
  Close Time Is Required
</div>
</div>
  <div class="col-md-4">
    <mat-form-field class="example-full-width">
              <mat-label> Description</mat-label>
              <textarea matInput placeholder="Short Description" name="description" [(ngModel)]="addForm.description" value=""></textarea>
              
            </mat-form-field>
  </div>
  <div class="col-md-4">
  <mat-slide-toggle
  [(ngModel)]="addForm.status"
  name="status"
  #status="ngModel"
  >status</mat-slide-toggle
></div>
  
</div> 
    <br>     <button mat-raised-button [disabled]="f.invalid">ADD RESTAURANT</button>
      </form>
      </mat-card></div>